import { render, staticRenderFns } from "./AddEditProfile.vue?vue&type=template&id=241fa0f8"
import script from "./AddEditProfile.vue?vue&type=script&lang=js"
export * from "./AddEditProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports